import React from "react";

function WorkPage() {
  return <div>WorkPage</div>;
}

export default WorkPage;
